module.exports = "//cdn.mxpnl.com/static/asset-cache/f94fc9c4276ab992058ef24c5b1e951e/iron/common/assets/images/charts/rolling-line.svg";